import { render, staticRenderFns } from "./WidgetCard.vue?vue&type=template&id=bb2d60fe&scoped=true&"
import script from "./WidgetCard.vue?vue&type=script&lang=js&"
export * from "./WidgetCard.vue?vue&type=script&lang=js&"
import style0 from "./WidgetCard.vue?vue&type=style&index=0&id=bb2d60fe&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb2d60fe",
  null
  
)

export default component.exports